import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { name: '首页', path: '/' },
  { name: '分类', path: '/category/rexue' },
  { name: '排行榜', path: '/#ranking' },
  { name: '最新更新', path: '/#latest' },
  { name: '关于我们', path: '/about' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-3 group">
            <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500">
              <i className="ri-book-open-line text-background-50 text-xl"></i>
            </div>
            <span className={`font-heading text-xl font-bold transition-colors ${
              scrolled || !isHome ? 'text-foreground-900' : 'text-background-50'
            }`}>
              哔咔漫画
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                  location.pathname === link.path
                    ? 'bg-primary-500 text-background-50'
                    : scrolled || !isHome
                      ? 'text-foreground-700 hover:text-foreground-900 hover:bg-background-200'
                      : 'text-background-50/90 hover:text-background-50 hover:bg-background-50/10'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <div className="relative">
              <input
                type="text"
                placeholder="搜索漫画..."
                className={`pl-10 pr-4 py-2 rounded-full text-sm border transition-colors w-48 focus:w-64 focus:outline-none ${
                  scrolled || !isHome
                    ? 'bg-background-100 border-background-200 text-foreground-800 placeholder-foreground-400 focus:border-primary-400'
                    : 'bg-background-50/10 border-background-50/20 text-background-50 placeholder-background-50/50 focus:border-background-50'
                }`}
              />
              <i className={`ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-sm ${
                scrolled || !isHome ? 'text-foreground-400' : 'text-background-50/60'
              }`}></i>
            </div>
            <Link
              to="/category/rexue"
              className={`px-5 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap ${
                scrolled || !isHome
                  ? 'bg-primary-500 text-background-50 hover:bg-primary-600'
                  : 'bg-background-50/15 text-background-50 border border-background-50/25 hover:bg-background-50/25'
              }`}
            >
              开始阅读
            </Link>
          </div>

          <button
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg ${
              scrolled || !isHome ? 'text-foreground-800' : 'text-background-50'
            }`}
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={mobileOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 px-4 py-4">
          <div className="flex flex-col gap-2">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setMobileOpen(false)}
                className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                  location.pathname === link.path
                    ? 'bg-primary-500 text-background-50'
                    : 'text-foreground-700 hover:text-foreground-900 hover:bg-background-100'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <div className="relative mt-2">
              <input
                type="text"
                placeholder="搜索漫画..."
                className="pl-10 pr-4 py-3 rounded-full text-sm border bg-background-100 border-background-200 text-foreground-800 placeholder-foreground-400 focus:border-primary-400 focus:outline-none w-full"
              />
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-sm text-foreground-400"></i>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}